const initialState = {
  unverifiedVisits: [],
  sinlgeUnverifiedVisit: null
}

export default function visits(state=initialState, action) {

  switch (action.type) {
    case 'FETCH_UNVERIFIED_VISITS':
      return {...state, unverifiedVisits: action.unverifiedVisits}
    case 'FETCH_SINGLE_UNVERIFIED_VISIT':
      return {...state, sinlgeUnverifiedVisit: action.sinlgeUnverifiedVisit}
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/verification.js